import React from 'react';
import WebhookProcessManage from '../WebhookProcessManage/WebhookProcessManage';
import { useTranslation } from 'react-i18next';
import { GET_WEBHOOK_QUEUE_LOG_INFO, GET_WEBHOOK_QUEUE_LOGS, PERFORM_ACTION_WEBHOOK_QUEUE_LOG } from '../../utils/ApiEndpoints';
import { pageTypes } from '../../utils/WebhookProcessManageUtil';

const WebhookLogQueue = () => {
  const { t } = useTranslation();

  const tc = (e, data) => (data ? t(`webhooklogqueue:${e}`, data) : t(`webhooklogqueue:${e}`));

  const topGridAllColumnNames = [
    {
      field: 'id',
      header: tc('ID_HEADER'),
      filterPlaceholder: tc('ID_FILTER_PLACEHOLDER'),
    },
    {
      field: 'glType',
      header: tc('GL_TYPE_HEADER'),
      filterPlaceholder: tc('GL_TYPE_FILTER_PLACEHOLDER'),
    },
    {
      field: 'status',
      header: tc('STATUS_HEADER'),
      filterPlaceholder: tc('STATUS_FILTER_PLACEHOLDER'),
    },
    {
      field: 'createdTime',
      header: tc('CREATED_TIME_HEADER'),
      filterPlaceholder: tc('CREATED_TIME_FILTER_PLACEHOLDER'),
    },
    {
      field: 'updatedTime',
      header: tc('UPDATED_TIME_HEADER'),
      filterPlaceholder: tc('UPDATED_TIME_FILTER_PLACEHOLDER'),
    },
  ];

  const bottomGridColumns = [
    { field: 'id', header: 'Id', style: { width: '76px' } },
    { field: 'signature', header: 'Signature', style: { width: '374px' } },
    { field: 'payload', header: 'Payload', style: { width: '605px' } },
    { field: 'actionType', header: 'Action Type' },
  ];

  return (
    <WebhookProcessManage
      topGridAllColumnNames={topGridAllColumnNames}
      bottomGridAllColumns={bottomGridColumns}
      pageType={pageTypes.webhookLogQueue}
      loadQueueAPI={GET_WEBHOOK_QUEUE_LOGS}
      loadDetailsAPI={GET_WEBHOOK_QUEUE_LOG_INFO}
      performActionAPI={PERFORM_ACTION_WEBHOOK_QUEUE_LOG}
      pageHeader={tc('WEBHOOK_LOG_PAGE_HEADER')}
      topTableHeader={tc('WEBHOOK_TOP_TABLE_HEADER')}
      bottomTableHeader={tc('WEBHOOK_BOTTOM_TABLE_HEADER')}
      bottomTableEmptyMsg={tc('NO_ROWS_BOTTOM_DEFAULT_TEXT')}
      bottomGridKey="signature"
      bottomPaginator={false}
    />
  );
};

export default WebhookLogQueue;